import CardSection from 'elem/compPage/delta-3-max-series/pages/product/components/CardSection';
import VideoSection from 'elem/compPage/delta-3-max-series/pages/product/components/Common/VideoSection';
import CutCosts from 'elem/compPage/delta-3-max-series/pages/product/components/CutCosts';
import Explore from 'elem/compPage/delta-3-max-series/pages/product/components/Explore';
import PhoneSection from 'elem/compPage/delta-3-max-series/pages/product/components/PhoneSection';
import TabSection from 'elem/compPage/delta-3-max-series/pages/product/components/TabSection';
import TC from 'elem/compPage/delta-3-max-series/pages/product/components/TC';
import Automotive from 'elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/Automotive';
import Automotive2 from 'elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/Automotive2/index.';
import Banner from 'elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/Banner';
import Built from 'elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/Built';
import ChargeUp from 'elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/ChargeUp';
import Essentials from 'elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/Essentials';
import OnePicture from 'elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/OnePicture';
import PriorityOutputs from 'elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/PriorityOutputs';
import Redfine from 'elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/Redifine';
import Subscribe from 'elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/Subscribe';
import { useState } from 'react';
import Output from '../components/Output';

import getLocal from '@/app/utils/i18n';
import { useLang } from '@/i18n';
import ProductNav from '../../../common/ProductNav';
import Bundles from '../Bundles';
import Comparison from '../components/Comparison';
import TwoEasy from '../components/TwoEasy';
import * as config from './config';
import styles from './index.module.scss';
import CoreAnimation from '@elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/CoreAnimation';
import './nav.scss';
import PageNavLeft from '@elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/PageNavLeft';
import BottomAction from '../components/BottomAction';

const StatusA: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('StatusA');
    const { t: tPageNavLeft } = useLang('PageNavLeft');

    const [activeTab, setActiveTab] = useState('Product');

    const video5Config = config.getCoverSectionConfig('video5');
    const video6Config = config.getCoverSectionConfig('video6');
    const video7Config = config.getCoverSectionConfig('video7');
    const video8Config = config.getCoverSectionConfig('video8');

    const tabSectionConfig = config.getTabSectionConfig();
    const cardSectionConfig = config.getCardSectionConfig();
    const phoneSectionConfig = config.getPhoneSectionConfig();
    const cutCostsConfig = config.getCutCostsConfig();
    const exploreConfig = config.getExploreConfig();
    const tcConfig = config.getTcConfig();

    return (
        <div className={styles.StatusA} id="StatusA">
            <ProductNav activeTab={activeTab} tabCallback={setActiveTab} />

            {activeTab === 'Product' && (
                <>
                    <BottomAction pageType="ultra" />
                    <Banner pageType="ultra" />
                    {/* <Redfine />
                    <OnePicture pageType="ultra" /> */}
                    <CoreAnimation pageType="ultra" />
                    <div className="range1">
                        <Subscribe pageType="ultra" />
                    </div>

                    <div className="range2">
                        <div id="videoSection5">
                            <VideoSection key="VideoSection5" {...video5Config} />
                        </div>
                        <PriorityOutputs pageType="ultra" />
                        <Output />
                        <Essentials pageType="ultra" />
                    </div>

                    <div className="range3">
                        <div id="videoSection6">
                            <VideoSection key="VideoSection6" {...video6Config} />
                        </div>

                        <TabSection key="TabSection" config={tabSectionConfig} />
                        <CardSection key="CardSection" config={cardSectionConfig} />
                        <TwoEasy />
                    </div>
                    <div className="range4">
                        <div id="videoSection7">
                            <VideoSection key="VideoSection7" {...video7Config} />
                        </div>
                        <ChargeUp pageType="ultra" />
                    </div>

                    <div className="range5">
                        <div id="videoSection8">
                            <VideoSection key="VideoSection8" {...video8Config} />
                        </div>
                        <Automotive />
                        <Automotive2 />
                        <Built pageType="ultra" />
                    </div>
                    <div className="range6">
                        <PhoneSection key="PhoneSection" config={phoneSectionConfig} />
                        <div style={{ background: '#18191b' }}>
                            <CutCosts key="CutCosts" {...cutCostsConfig} />
                            <Comparison key="Comparison" />
                        </div>
                        <Explore key="Explore" config={exploreConfig} />
                        <TC key="TC" {...{ config: { ...tcConfig } }} />
                    </div>

                    {/* 左侧锚点 */}
                    <PageNavLeft
                        triggerElement={`#StatusA`}
                        enterElement="#OnePicture"
                        triggerElements={[{ selectors: `#StatusA`, theme: 'white' }]}
                        steps={[
                            { text: tPageNavLeft('item1'), href: '#overview-item1' },
                            { text: tPageNavLeft('item2'), href: '#videoSection5' },
                            { text: tPageNavLeft('item3'), href: '#videoSection6' },
                            { text: tPageNavLeft('item4'), href: '#videoSection7' },
                            { text: tPageNavLeft('item5'), href: '#videoSection8' },
                            { text: tPageNavLeft('item6'), href: '#phoneSection' },
                        ]}
                    />
                </>
            )}
            {activeTab === 'Bundles' && (
                <>
                    <Bundles />
                </>
            )}
            {activeTab === 'Specs' && <></>}
            {activeTab === 'Support' && <></>}
        </div>
    );
};

export default StatusA;
